import React, { ReactNode } from 'react';

import { AppModal } from 'src/components/AppModal';
import { InfrastructureTypes } from 'src/typings/spinner';
import { useSelector } from 'react-redux';
import { requestSelectors } from 'src/store/requests/selectors';
import { useStyles } from './styles';

interface IInfrastructureModal {
  isOpen: boolean;
  toggleClose: () => any;
  contentHeader?: ReactNode;
  type?: InfrastructureTypes
}

export const InfrastructureModal: React.FC<IInfrastructureModal> = ({
  contentHeader,
  isOpen,
  toggleClose,
  type,
  children,
}) => {
  const mainColor = useSelector(requestSelectors.app.getMainColors);
  const styles = useStyles(mainColor);

  return (
    <AppModal
      open={isOpen}
      toggleClose={toggleClose}
      listClassName={{
        wrapperModal: styles.wrapperModal,
        modalWindow: styles.modalWindow,
        wrapperContent: type !== InfrastructureTypes.iframe ? styles.wrapperContent : styles.iframeWrapperContent,
        customCloseButton: styles.closeButton,
      }}
      contentHeader={contentHeader || <div />}
    >
      <>
        {children}
      </>
    </AppModal>
  );
};
